import styled from "@emotion/styled";

export const CustomerRFQPageLayout = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20% 0;
`;

export const CustomerRFQContents = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 100px;
  border-radius: 5px;
  padding: 10px;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='5' ry='5' stroke='%238495A3FF' stroke-width='2' stroke-dasharray='4 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
`;
